angular.module('rjmNg.directives').directive 'accessGroup', [
  () ->
    restrict: 'E'
    templateUrl: 'settings/directive.accessGroup.html'
    replace: true
    scope: {}
    controllerAs: 'view'
    bindToController: true
    controller: [
      "$routeParams"
      "$window"
      "Invites"
      "notification"
      "$scope"
      "$http"
      "$url"
      "userService"
      "accessGroupService"
      "$q"
      "app"
      "USER_PERMISSION"
      "errorConstants"
      (
        $routeParams
        $window
        Invites
        notification
        $scope
        $http
        $url
        userService
        accessGroupService
        $q
        app
        USER_PERMISSION
        errorConstants
      ) ->

        view = @

        view.accessOptions = USER_PERMISSION.ACCESS
        view.isSupportUser = app.isSupportUserSession()
        view.loading = false
        view.useInviteSystem = false # temporary flag until we resolve metric rights issue
        view.allStores = []

        notificationMessages =
          success: "Invitation successful."
          error: "Invitation failed. Please try again."
          groupEditSuccess: "Group List updated sucessfully."
          groupEditError: "Group List update failed."
          groupSaveSuccess: "Group List saved sucessfully."
          groupSaveError: "Group List failed to save."
          groupDeleteSuccess: ""
          groupDeleteError: "Group failed to delete"

          # Function to fetch group names and stores from the API
        _initGroupData =  ->
          accessGroupService.groups({clientId: view.clientId}).then(
            (response) ->
              accessGroups = response.data
              groupData = []
              listAccessGroup = (accessGroup) ->
                store_names = accessGroup.stores.map((store) -> store.name).join(', ')
                store_ids = accessGroup.stores.map((store) -> store.id).join(', ')
                groupData.push({ id: accessGroup.id, name: accessGroup.name, store_names: store_names, store_ids: store_ids })

              if Array.isArray(accessGroups)
                for accessGroup in accessGroups
                  listAccessGroup(accessGroup)
              else if typeof accessGroups is 'object' and accessGroups isnt null
                listAccessGroup(accessGroups)

              view.groupData = groupData
          )
            .catch((error) ->
              console.error('Error fetching group data:', error)
              []
            )

        fetchOptionsFromAPI = ->
          accessGroupService.stores({clientId: view.clientId}).then(
            (response) ->
              view.allStores = response.data
              view.storesDropdownOptions = (for own key, value of response.data
                  { id: key, name: value }
            ))
            .catch((error) ->
              notification.error("Server Error",
                errorConstants.SERVER_ERROR_MESSAGE,
                "access-groups",
                null,
                15
              ))

        view.goBack = ->
          $window.history.back()

        # Function to open the pop-up
        view.addGroup = ->
          popup = document.getElementById("popup")
          overlay = document.getElementById("overlay")
          popup.style.display = "block"
          overlay.style.display = "block"
          _clearValuesOfPopUp()

        _clearValuesOfPopUp = ->
          userGroupInput = document.querySelector(".userGroup")
          userGroupInput.value = ""

          checkboxes = document.querySelectorAll('input[type="checkbox"].mydrp')
          for checkbox in checkboxes
            checkbox.checked = false

          view.apiErrorMessage = document.getElementById('apiErrorMessage')
          view.apiErrorMessage.innerHTML = ""

        # Function to close the pop-up
        view.closePopup = ->
          popup = document.getElementById("popup")
          overlay = document.getElementById("overlay")
          popup.style.display = "none"
          overlay.style.display = "none"
          view.editingGroupId = null
          _clearValuesOfPopUp()

        view.saveGroup = ->
          groupName = $('.userGroup').val() 
          storeIds = $('.dropdown-list input[type=checkbox]:checked').map (i, el) -> parseInt($(el).val())
          storeIds = $.makeArray(storeIds)
          data = 
            group_name: groupName
            store_ids: storeIds

          if view.editingGroupId?
            accessGroupService.edit(view.editingGroupId, data)
              .then ((response) ->
                notification.success null, notificationMessages.groupEditSuccess, "access-groups", { dismissable: true, bindHtml: true }, 5
                view.closePopup()
                _init())
              .catch (error) ->
                displayErrorMessage(error.data)
                notification.error(null, notificationMessages.groupSaveError, "access-groups", { dismissable: true, bindHtml: true }, 5)
          else
            accessGroupService.save(data)
              .then((response) ->
                notification.success(null, notificationMessages.groupSaveSuccess, "access-groups", { dismissable: true, bindHtml: true }, 5)
                view.closePopup() 
                _init())
              .catch (error) ->
                displayErrorMessage(error.data)
                notification.error(null, notificationMessages.groupSaveError, "access-groups", { dismissable: true, bindHtml: true }, 5)

        view.hasSelectedStores = ->
          selectedOptions = $scope.view.storesDropdownOptions.filter (option) ->
            option.selected
          selectedOptions.length > 0
        
        view.deleteGroup = (group) ->
          storeIds = $('.dropdown-list input[type=checkbox]:checked').map (i, el) -> parseInt($(el).val())
          storeIds = $.makeArray(storeIds)
          data =
            group_name: group.group_name
            store_ids: storeIds
          confirmMessage = "Are you sure you want to delete this Group?"
          if confirm(confirmMessage)
            accessGroupService.delete(group.id, data)
              .then((response) ->
                if response.status
                  notificationMessages.groupDeleteSuccess =response.message
                  notification.success(null, notificationMessages.groupDeleteSuccess, "access-groups", { dismissable: true, bindHtml: true }, 5)
                  view.closePopup()
                  _init()
                else
                  confirmMessage = response.reason
                  if confirm(confirmMessage)
                    accessGroupService.forceDelete(group.id, data)
                      .then (response) ->
                        notificationMessages.groupDeleteSuccess = response.message
                        notification.success(null, notificationMessages.groupDeleteSuccess, "access-groups", { dismissable: true, bindHtml: true }, 5)
                        view.closePopup()
                        _init()
                      .catch (error) ->
                        displayErrorMessage(error.data)
                        notification.error(null, notificationMessages.groupDeleteError, "access-groups", { dismissable: true, bindHtml: true }, 5))
              .catch (error) ->
                displayErrorMessage(error.data)
                notification.error(null, notificationMessages.groupDeleteError, "access-groups", { dismissable: true, bindHtml: true }, 5)

        checkCheckboxesByIds = (idsString) ->
          ids = idsString.split(',').map((id) -> id.trim())
          for id in ids
            checkbox = document.querySelector("input[type='checkbox'].mydrp[id='#{id}']")
            
            if checkbox
              checkbox.checked = true

        view.editGroup = (group) ->
          if not group?
            console.error("Group is undefined")
            return
          _clearValuesOfPopUp()
          view.editingGroupId = group.id
          storeNames = (group.store_names or "").split(", ").filter(Boolean)
          userGroupInput = document.querySelector(".userGroup")
          userGroupInput.value = group.name or ""
          checkCheckboxesByIds(group.store_ids)

          popup = document.getElementById("popup")
          overlay = document.getElementById("overlay")
          popup.style.display = "block"
          overlay.style.display = "block"

        # Dropdown functionality
        searchInput = document.querySelector(".search-input")
        dropdownList = document.querySelector(".dropdown-list")
        options = []
        searchInput.addEventListener("input", () ->
          searchTerm = searchInput.value.toLowerCase()
          options = dropdownList.querySelectorAll("li")
          options.forEach((option) ->
            optionText = option.textContent.toLowerCase()
            if optionText.includes(searchTerm)
              option.style.display = "flex"
            else
              option.style.display = "none"
          )
        )

        document.addEventListener("click", (event) ->
          if not (event.target is searchInput)
            dropdownList.style.display = "none"
        )

        searchInput.addEventListener("click", () ->
          dropdownList.style.display = "block"
        )

        options.forEach((option) ->
          option.addEventListener("click", () ->
            searchInput.value = option.textContent
            dropdownList.style.display = "none"
          )
        )

        displayErrorMessage = (errorMessage) ->
          view.apiErrorMessage = document.getElementById('apiErrorMessage')
          view.apiErrorMessage.textContent = errorMessage

        _init = () ->
          _initNewUserInfo()
          _initGroupData()
          fetchOptionsFromAPI()

        _initNewUserInfo = () ->
          view.userName = null
          view.selectedAccess = USER_PERMISSION.ACCESS.STANDARD
          view.userData =
            email: null
            client_id: $routeParams.clientId
            client_rights: 
              billing: 0
              technical: 0

        view.$postLink = () ->
          _init()

        view
    ]

    link: (scope, element, attrs, controller) ->
      scope.$watch(
        'view.popupVisible',
        (newValue, oldValue) ->
          if newValue
            element.find('.popup').css('display', 'block')
          else
            element.find('.popup').css('display', 'none')
      , true)

]